/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { getRawValue } from '../interpreter/InterpreterValue';
export class AdvancedFind {
    constructor(dependencyGraph) {
        this.dependencyGraph = dependencyGraph;
    }
    advancedFind(keyMatcher, range) {
        const values = this.dependencyGraph.computeListOfValuesInRange(range);
        for (let i = 0; i < values.length; i++) {
            if (keyMatcher(getRawValue(values[i]))) {
                return i + range.start.col;
            }
        }
        return -1;
    }
}
